import React from 'react';
import { Card, CardHeader, CardContent, makeStyles } from '@material-ui/core';
import InvoiceTable from './InvoiceTable';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  cardTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  }
}));

const InvoicesSummary = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader title={t('invoicesTitle')} className={classes.cardTitle} />
      <CardContent>
        <InvoiceTable />
      </CardContent>
    </Card>
  );
};

export default InvoicesSummary;